import React from "react";
import "./courses.css";

const Courses = () => {
  return (
    <section id="courses" className="card-container">
      <h5>Bachelors in AI and Data Science</h5>
      <h2>Academic courses</h2>
      <div className="courses">
        <div className="list">
          <ul>
            <li>
              <span>Artificial Intelligence</span>
            </li>
            <li>
              <span>Machine Learning</span>
            </li>
            <li>
              <span>Operating Systems</span>
            </li>
            <li>
              <span>Databases Management</span>
            </li>
          </ul>
        </div>
        <div className="list">
          <ul>
            <li>
              <span>Web Computing</span>
            </li>
            <li>
              <span>Datawarehouse and Mining</span>
            </li>
            <li>
              <span>Data Analytics & Visualization</span>
            </li>
            <li>
              <span>Software Engineering</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Courses;
